/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Answer,
    AnswerFromJSON,
    AnswerFromJSONTyped,
    AnswerToJSON,
} from './';

/**
 * Entidad pregunta. Hay preguntas con respuestas fijas puntuadas (open) y hay preuntas de texto libre (closed).
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * 
     * @type {number}
     * @memberof Question
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    text?: string;
    /**
     * open, closed
     * @type {string}
     * @memberof Question
     */
    type?: string;
    /**
     * 
     * @type {Array<Answer>}
     * @memberof Question
     */
    answers?: Array<Answer>;
}

export function QuestionFromJSON(json: any): Question {
    return QuestionFromJSONTyped(json, false);
}

export function QuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Question {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'answers': !exists(json, 'answers') ? undefined : ((json['answers'] as Array<any>).map(AnswerFromJSON)),
    };
}

export function QuestionToJSON(value?: Question | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'text': value.text,
        'type': value.type,
        'answers': value.answers === undefined ? undefined : ((value.answers as Array<any>).map(AnswerToJSON)),
    };
}


